import { useQuery } from "@tanstack/react-query";
import { getImageCompressionCacheFiles } from "../openapi/api-client.ts";

export const useImageCompressionCacheFiles = (
  projectId: string,
  appInstallationId: string,
  enabled = true,
) => {
  return useQuery({
    queryKey: ["imageCompressionCacheFiles", { projectId, appInstallationId }],
    queryFn: async () => {
      const response = await getImageCompressionCacheFiles({
        path: { projectId, appInstallationId },
      });

      if (response.error) {
        throw new Error(
          response.error.message ||
            "error while fetching image compression cache files",
        );
      }

      return response.data;
    },
    enabled,
    staleTime: 60 * 60 * 1000, // 1 hour
  });
};
